import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router } from '@angular/router';

@Injectable({
  providedIn: 'root',
})
export class GoogleTokenGuard implements CanActivate {
  private ACCESS_TOKEN = 'access_token';

  constructor(private router: Router) {}

  public canActivate(route: ActivatedRouteSnapshot): boolean {
    const urlSearch = new URLSearchParams(route.fragment);
    const accessToken = urlSearch.get(this.ACCESS_TOKEN);
    if (accessToken) {
      const params = this.getParams(urlSearch);
      this.router.navigate([route.fragment.substring(0, route.fragment.indexOf('#'))], {
        queryParams: params,
      });
    }
    return true;
  }

  public getParams(urlSearch: URLSearchParams): any {
    const state = urlSearch.get('state');
    if (state) {
      const { params } = JSON.parse(this.decodeB64WithBinary(state));
      params[this.ACCESS_TOKEN] = urlSearch.get(this.ACCESS_TOKEN);
      return params;
    }
    return { access_token: urlSearch.get(this.ACCESS_TOKEN) };
  }

  decodeB64WithBinary(encoded) {
    const binary = atob(encoded);
    const bytes = new Uint8Array(binary.length);
    for (let i = 0; i < bytes.length; i++) {
      bytes[i] = binary.charCodeAt(i);
    }
    return String.fromCharCode(...new Uint16Array(bytes.buffer));
  }
}
